// Browser error tracking with Sentry. Off unless REACT_APP_SENTRY_DSN is set at build time
// (a Vercel environment variable). The SDK (~30 KB gzipped) is a separate chunk, fetched only when
// the DSN is set; the main bundle grows by a few hundred bytes either way.
//
// Reported: uncaught errors and unhandled promise rejections (including errors thrown while
// React renders), from the moment the chunk has loaded (errors in the first instant are missed). Not sent: tracing, session replay, request bodies, cookies, IPs or user details
// (sendDefaultPii stays off). Failing to load or start Sentry never affects the app.
export function initErrorTracking() {
  const dsn = (process.env.REACT_APP_SENTRY_DSN || '').trim();
  if (!dsn) return Promise.resolve(false);
  return import('@sentry/react')
    .then((Sentry) => {
      Sentry.init({
        dsn,
        environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || process.env.NODE_ENV,
        sendDefaultPii: false,
      });
      Sentry.setTag('component', 'frontend');
      return true;
    })
    .catch(() => false);
}
